import { Gender } from '../../common/enums/gender.enum'
import { LinkType } from '../../common/enums/link-type.enum'
import { ResourceDefinition } from '../../common/interfaces/resource-definition.interface'

export const roleDefinition: ResourceDefinition = {
  title: 'Rôles',
  nameSingular: 'rôle',
  namePlural: 'rôles',
  gender: Gender.Masculine,
  slug: 'roles',
  hasDetailPage: false,
  hasListPage: true,
  buttons: [LinkType.CREATE],
  defaultLink: LinkType.EDIT,
  dropdownLinks: [
    {
      type: LinkType.EDIT,
      permission: 'editRoles'
    },
    {
      type: LinkType.DELETE,
      permission: 'deleteRoles'
    }
  ],
  yields: [
    {
      label: 'Identifiant',
      property: 'name'
    },
    {
      label: 'Nom',
      property: 'displayName'
    }
  ]
}
